module.exports = __webpack_public_path__ + "img/Leopards Express.7858cb5c.png";